export function resolveSaveOverwriteTarget({ loadId, modelName, savedModels }) {
  const name = String(modelName || '').trim();
  if (!name) {
    return null;
  }

  const models = savedModels || [];

  if (loadId) {
    const loaded = models.find((model) => model.id === loadId);
    if (loaded?.name === name) {
      return loaded.name;
    }
  }

  const existing = models.find((model) => model.name === name);
  return existing ? existing.name : null;
}

/** Name of an existing saved model the user can overwrite from the Save dialog. */
export function resolveSaveDialogOverwriteName({ loadId, modelName, savedModels }) {
  const models = savedModels || [];

  if (loadId) {
    const loaded = models.find((model) => model.id === loadId);
    if (loaded?.name) {
      return loaded.name;
    }
  }

  const name = String(modelName || '').trim();
  if (!name) {
    return null;
  }

  const existing = models.find((model) => model.name === name);
  return existing ? existing.name : null;
}
